import React, { useId } from 'react'
import { Clock } from 'lucide-react'
import { buildQuotationCountdownBadge } from '../DashboardHeader/ConversationalMode/MessageBubble/rubroQuotationTimelineUtils.ts'
import RubroQuotationTimeline from '../DashboardHeader/ConversationalMode/MessageBubble/RubroQuotationTimeline.tsx'
import panelStyles from './RubroQuotationDatesPanel.module.scss'

export type RubroQuotationDatesPanelProps = {
  projectStartDate: string
  projectEndDate: string
  windowStartDate: string
  windowEndDate: string
  className?: string
}

const RubroQuotationDatesPanel: React.FC<RubroQuotationDatesPanelProps> = ({
  projectStartDate,
  projectEndDate,
  windowStartDate,
  windowEndDate,
  className
}) => {
  const headingId = useId()
  const countdownBadge = buildQuotationCountdownBadge(windowStartDate, windowEndDate)

  return (
    <section
      className={[panelStyles.panel, className].filter(Boolean).join(' ')}
      aria-labelledby={headingId}
    >
      <div className={panelStyles.card}>
        <div className={panelStyles.head}>
          <h4 id={headingId} className={panelStyles.title}>
            Ventana de cotización
          </h4>
          <div className={panelStyles.daysLeft}>
            <Clock size={16} aria-hidden />
            <span className={panelStyles.daysLeftValue}>{countdownBadge.amountLabel}</span>
            <span className={panelStyles.daysLeftCaption}>{countdownBadge.caption}</span>
          </div>
        </div>
        <RubroQuotationTimeline
          projectStartDate={projectStartDate}
          projectEndDate={projectEndDate}
          windowStartDate={windowStartDate}
          windowEndDate={windowEndDate}
        />
      </div>
    </section>
  )
}

export default RubroQuotationDatesPanel
